import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ExecutorFilter} from '../../../util/executor-filter';
import {FilterSearch} from '../../model/filtro.model';

@Component({
    selector: 'filter-event',
    templateUrl: './filter-event-dialog.component.html',
    styleUrls: ['./filter-event-dialog.scss']
})
// tslint:disable-next-line:component-class-suffix
export class FilterEventDialog {

    id: number;
    description: string;
    executorFilter: ExecutorFilter;

    constructor(public _dialogRef: MatDialogRef<FilterEventDialog>) {
    }

    executeFilter(): void {
        const filters = new Array<FilterSearch>();
        if (this.id) {
            filters.push(new FilterSearch('id', this.id));
        }

        if (this.description) {
            filters.push(new FilterSearch('description', this.description));
        }

        this.executorFilter.executeFilter(filters);
        this.close();
    }

    close(): void {
        this._dialogRef.close();
    }
}
